module.exports = __webpack_public_path__ + "static/media/44.31ceb9ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/44.svg
// module id = 2836
// module chunks = 3